import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskLeadEditComponent } from './task-lead-edit.component';
import { CtButtonModule, CtFormModule } from '@ctsolution/ct-framework';
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';

@NgModule({
  imports: [
    CommonModule,
    CtFormModule,
    MatCardModule,
    CtButtonModule,
    FlexLayoutModule,
    MatLegacyButtonModule,
  ],
  declarations: [TaskLeadEditComponent],
  exports: [TaskLeadEditComponent]
})
export class TaskLeadEditModule { }
